import React, { useEffect, useMemo } from 'react'
import { Panel } from '@sencha/ext-modern'
import { useInstData } from 'tyan/public/hooks'
import PivotView from './PivotView'
import { getDataCols } from 'tyan/public/components/column'

const PivotManager = props => {
	const { me, setState, me: { state: { showed = false, data } } } = useInstData(props)
	const { config, onClose, onGetData } = props
	const { pivot, settings, otherSettings, calcData } = useMemo(() => {
		const pivot = config.pivot === true ? {} : config.pivot
		const settings = pivot.settings || {}
		const otherSettings = pivot.otherSettings || {}
		return { pivot, settings, otherSettings, calcData: pivot.calcData }
	}, [])

	// console.log('PivotManager props:', props, data)
	const cols = getDataCols(pivot.columns || config.columns)
	const doGetData = () => {
		const setData = list => {
			list.forEach(data => (delete data.id, cols.forEach(col => col.field && col.field !== col.name && delete data[col.field])))
			calcData && (list = list.map(calcData))
			!me.unmounted && setState({ data: list })
		}
		onGetData ? onGetData(pivot.columns, setData) : onClose && onClose()
	}

	useEffect(() => {
		const checkHeight = () => {
			me.container && me.container.clientHeight
				? (!me.unmounted && setState({ showed: true }))
				: setTimeout(checkHeight, 100)
		}
		setTimeout(checkHeight, 100)
		doGetData()
	}, [])

	return <>
		<Panel layout='fit' margin={"5 10 10 10"} shadow >
			<div style={{ width: '100%', height: '100%' }}>
				<div /* id='pr1'  */ style={{ /* padding: '10px 10px 10px 10px',  */width: '100%', height: '100%' }}
					ref={ref => ref && (me.container = ref)}
				>
					{!data ? '请稍等' : showed && <PivotView {...{ data, onClose, settings, otherSettings }} /> || null}
				</div>
			</div>
		</Panel>
	</>
}

export default PivotManager